<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="Custom container h-100">
    <div class="content">
      <div class="header" style="width: 100%">
        <el-row style="margin-bottom: 10px;padding-top:10px">
          <el-col :span="22">
            <el-divider content-position="left">
              <el-link :underline="true" @click="initList">回款记录认领 <i class="el-icon-refresh"></i></el-link>
              <span style="margin-left: 20px;font-weight: 600">&nbsp;&nbsp;状态：</span>
              <el-checkbox-group v-model="searchCondition.claim_status" style="display: inline" @change="searchRecord">
                <el-checkbox :label="option.label" :value="option.value" v-for="(option,key) in claimStatusOption"
                             :key="key">
                  {{ option.value }}
                </el-checkbox>
              </el-checkbox-group>
            </el-divider>
          </el-col>
          <el-col :span="2" style="text-align: right">
            <el-button type="primary" class="el-button--operation" size="small" @click="showSearch"
                       v-if="userAuth.can_search_tick_pay_record">&nbsp;筛&nbsp;选&nbsp;<i
                class="el-icon-search"></i></el-button>
          </el-col>
        </el-row>

        <div v-loading="loading"
             element-loading-text="回款记录加载中……"
             element-loading-spinner="el-icon-loading" class="default-table">
          <el-table
              :data="tableData"
              :height="tblHeight"
              :highlight-current-row="true"
              ref="tableRef"
              border>
            <el-table-column width="80" fixed="left">
              <template slot-scope="scope">
                <span><el-link type="primary" @click="claimRecord(scope.row)"><i
                    class="el-icon-check"></i>是我的</el-link></span>
                <span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="claim_status"
                label="状态"
                width="80" align="center">
              <template slot-scope="scope">
                <span :class="statusClass(scope.row.claim_status)">{{ scope.row.claim_status_alias }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="pay_date"
                label="收款日期"
                width="100">
              <template slot-scope="scope">
                <span :title="`记录ID:${scope.row.id}`">{{ scope.row.pay_date }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="payer"
                label="付款方名称"
                width="120"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="account"
                label="收款金额"
                width="120"
                header-align="center"
                align="right">
              <template slot-scope="scope">
                <span class="money">{{ moneyFormat(scope.row.account) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="sum_payment"
                label="认领金额"
                width="120"
                header-align="center"
                align="right">
              <template slot-scope="scope">
                <span class="money">{{ moneyFormat(scope.row.sum_payment) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="bank_account"
                label="银行账号"
                width="200"
                header-align="center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="bank_name"
                label="开户行"
                width="180"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="rec_name"
                label="收款方"
                width="140"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true"
            >
            </el-table-column>
            <el-table-column
                prop="pay_method"
                label="收款方式"
                width="100"
                header-align="center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="notify_at"
                label="通知已发"
                width="100"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="owmer_name"
                label="认领归属"
                width="100"
                header-align="center"
                align="center">
              <template slot-scope="scope">
                <span v-if="userAuth.can_view_all_pay_record">{{ scope.row.owmer_name }}</span>
                <div v-else>
                  <span v-if="scope.row.owner_id===user.id" style="font-weight: lighter">{{
                      scope.row.owmer_name
                    }}</span>
                  <span v-else style="font-weight: lighter">***</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="claim_at"
                label="认领时间"
                width="100"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="check_at"
                label="确认时间"
                width="100"
                header-align="center"
                align="center" :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="100"
                header-align="center"
                align="left" :show-tooltip-when-overflow="true">
              <template slot-scope="scope">
                <span v-if="scope.row.owner_id===user.id" style="font-weight: lighter">{{ scope.row.remark }}</span>
                <span v-else style="font-weight: lighter">--</span>
              </template>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24" style="text-align: right;margin-top: 10px">
              <el-pagination
                  v-if="initPaging"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  :page-size="pageSize"
                  :layout="defaultLayout"
                  :total="dataTotal"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--    筛选条件 -->
    <el-drawer
        title="筛选条件"
        :visible.sync="showCondDrawer"
        :direction="direction">
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form ref="searchCondition" :model="searchCondition" label-width="80px">
            <el-form-item label="付款方：">
              <el-input v-model="searchCondition.payer"></el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-checkbox-group v-model="searchCondition.claim_status" style="display: inline" @change="searchRecord">
                <el-checkbox :label="option.label" :value="option.value" v-for="(option,key) in claimStatusOption"
                             :key="key">
                  {{ option.value }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="收款时间">
              <el-date-picker
                  v-model="searchCondition.time_value"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款月份">
              <el-date-picker
                  v-model="searchCondition.ym"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款方：">
              <el-input v-model="searchCondition.rec_name" clearable></el-input>
            </el-form-item>

            <!--            <el-form-item label="收款方式">-->
            <!--              <el-select v-model="searchCondition.pay_method" placeholder="请选择收款方式">-->
            <!--                <el-option-->
            <!--                    v-for="item in payMethodOptions"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" @click="onSubmit" class="el-button--operation">筛选</el-button>
              <el-button @click="clearCondition">全部清除</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-drawer>

    <!--    认领 -->
    <el-dialog
        title="回款记录认领"
        :visible.sync="dialogVisible"
        width="98%" :close-on-press-escape="false" :close-on-click-modal="false">
      <div>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>付款信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="24" style="text-align: left">
                    <span class="payer" style=""> {{
                        currentRecord.payer
                      }}</span>
                  </el-col>
                </el-row>
                <el-form :model="currentRecord" size="small">
                  <el-form-item label="付款银行：">
                    <span>{{ currentRecord.bank_name }}</span>
                  </el-form-item>
                  <el-form-item label="收款日期：">
                    <span>{{ currentRecord.pay_date }}</span>
                  </el-form-item>
                  <el-form-item label="收款方式：">
                    <span>{{ currentRecord.pay_method }}</span>
                  </el-form-item>
                  <el-form-item label="收款金额：">
                    <span class="total-money">{{ moneyFormat(currentRecord.account) }}</span>
                  </el-form-item>
                  <el-form-item label="认领金额：">
                    <span class="sum-payment">{{ moneyFormat(currentRecord.sum_payment || 0) }}</span>
                  </el-form-item>
                  <!--                  <el-form-item label="我认领金额：">-->
                  <!--                    <span class="my-balance-money">{{-->
                  <!--                        moneyFormat(totalPayment)-->
                  <!--                      }}</span>-->
                  <!--                  </el-form-item>-->
                  <!--                  <el-form-item label="剩余可分配：">-->
                  <!--                    <span class="balance-money">{{-->
                  <!--                        moneyFormat(currentRecord.account - currentRecord.other_claim_account - totalPayment)-->
                  <!--                      }}</span>-->
                  <!--                  </el-form-item> -->
                  <el-form-item label="剩余可分配：">
                    <span class="balance-money">{{
                        moneyFormat(currentRecord.account - currentRecord.sum_payment)
                      }}</span>
                  </el-form-item>
                  <el-form-item label="收款方：">
                    <span>{{ currentRecord.rec_name || '--' }}</span>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
          <el-col :span="19">
            <el-card class="box-card-right">
              <div slot="header" class="clearfix">
                <span>认领情况(回款记录ID:{{ currentRecord.id }})</span>
                &nbsp;&nbsp;&nbsp;
                <span class="account">
                  收款金额：
                  <span class="money">{{ moneyFormat(currentRecord.account) }}</span>
                </span>
                &nbsp;&nbsp;
                <span class="account">
                 <span style="font-weight: 600">认领金额（他人认领 + 我认领）：</span>
                  <span class="money">{{ moneyFormat(currentRecord.sum_payment) }}</span>
                （<span class="money">{{ moneyFormat(currentRecord.other_claim_account) }}</span>
                  +
                 <span class="money">{{ moneyFormat(currentRecord.my_claim_account) }}</span>）
                </span>
              </div>
              <el-row>
                <el-col :span="24">
                  <div class="default-table" v-loading="loadingSheet"
                       element-loading-text="详情加载中……"
                       element-loading-spinner="el-icon-loading">
                    <el-table
                        :data="paySheets" border>
                      <el-table-column
                          label="操作项"
                          width="80" fixed="left">
                        <template slot-scope="scope">
                          <span>
                            <el-link type="danger" @click="cancel(scope.row)"
                                     :disabled="!([0].indexOf(scope.row.check_status)>-1&&scope.row.owner_id===user.id)"
                                     title="自己的未撤销记录才能撤销">
                              <i class="el-icon-delete"></i>撤销
                            </el-link>
                            </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="check_status"
                          label="状态"
                          width="80" align="center">
                        <template slot-scope="scope">
                          <span :class="checkStatusClass(scope.row.check_status)">{{
                              scope.row.check_status_alias
                            }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="记录ID" width="80" prop="id" align="center"></el-table-column>
                      <el-table-column label="乙方名称" width="80" prop="company_name" align="center"></el-table-column>
                      <el-table-column
                          prop="owner_id"
                          label="认领人"
                          align="center">
                        <template slot-scope="scope">
                          <span>{{ scope.row.owner_name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="created_at"
                          label="认领时间"
                          align="center" width="140" :show-tooltip-when-overflow="true">
                        <template slot-scope="scope">
                          <span>{{ scope.row.created_at }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="created_date"
                          label="下单时间"
                          width="100" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="customer_name"
                          label="客户名称"
                          width="160" header-align="center" align="left" :show-overflow-tooltip="true">
                      </el-table-column>
                      <el-table-column
                          prop="payment_account"
                          label="含税收入"
                          header-align="center"
                          align="right">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment_account) }}</span>
                        </template>
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="sum_amount"-->
                      <!--                          label="剩余金额"-->
                      <!--                          width="120"-->
                      <!--                          header-align="center"-->
                      <!--                          align="right"-->
                      <!--                      >-->
                      <!--                        <template slot-scope="scope">-->
                      <!--                          <span class="money">{{ moneyFormat(scope.row.payment_account - scope.row.sum_amount) }}</span>-->
                      <!--                        </template>-->
                      <!--                      </el-table-column>-->
                      <el-table-column
                          prop="payment"
                          label="本次回款金额"
                          width="120"
                          header-align="center"
                          align="right">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="payment_remark"
                          label="认领备注"
                          header-align="center"
                          align="left">
                      </el-table-column>
                      <el-table-column
                          prop="artist_name"
                          label="红人名称"
                          align="center">
                      </el-table-column>
                      <el-table-column
                          prop="platforms"
                          label="平台" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="brand"
                          label="品牌" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="product"
                          label="产品/内容" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="release_at"
                          label="要求发布时间" align="center">
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="bool_exec_alias"-->
                      <!--                          label="是否执行" align="center">-->
                      <!--                      </el-table-column>-->
                      <el-table-column
                          prop="pay_status_alias"
                          label="回款状态" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="order_no"
                          label="订单编号" width="140">
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <br/>
            <el-card class="box-card-right">
              <div slot="header" class="clearfix">
                <span>订单选择(仅限你销售未认领广告订单)</span>&nbsp;&nbsp;
                <span style="font-weight: 400"> -> 填写本次回款金额/备注</span>
                <span style="font-weight: 400"> -> 提交</span>
                <span style="font-weight: 400"> -> 等待确认</span>
              </div>
              <el-row>
                <el-col :span="24">
                  <el-form :inline="true" :model="formOrder" class="demo-form-inline" size="mini">
                    <el-form-item label="客户名称：">
                      <el-input v-model="formOrder.customer_name" placeholder="客户名称" clearable
                                @change="querySubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="客户检索：">
                      <CustomerSearch :name="searchKeyword" style="width: 100%" clearable
                                      @handleSelect="handleSelect"/>

                    </el-form-item>
                    <el-form-item label="品牌：">
                      <el-input v-model="formOrder.brand" placeholder="品牌" clearable
                                @change="querySubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="平台：">
                      <el-input v-model="formOrder.platforms" placeholder="平台" clearable
                                @change="querySubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="红人名称：">
                      <el-input v-model="formOrder.artist_name" placeholder="红人名称" clearable
                                @change="querySubmit"></el-input>
                    </el-form-item>

                    <el-form-item label="产品/内容：">
                      <el-input v-model="formOrder.product" placeholder="产品/内容" clearable
                                @change="querySubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="回款状态：">
                      <el-select v-model="formOrder.pay_status" placeholder="回款状态" style="width: 260px" clearable
                                 @change="querySubmit" multiple>
                        <el-option label="待回款" :value="0"></el-option>
                        <el-option label="部分回款" :value="1"></el-option>
                        <el-option label="已回款" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否执行：">
                      <el-select v-model="formOrder.bool_exec" placeholder="是否执行" style="width: 120px" clearable
                                 @change="querySubmit">
                        <el-option label="已执行" :value="1"></el-option>
                        <el-option label="未执行" :value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="发布时间：">
                      <el-date-picker
                          v-model="formOrder.time_value"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd" style="width: 240px">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="订单编号" class="search-item">
                      <el-input v-model="formOrder.order_no" placeholder="请输入订单编号" size="mini"
                                @change="onSubmit" clearable/>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="querySubmit">筛选</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="default-table">
                    <el-table
                        v-loading="loadingOrder"
                        element-loading-text="加载中……"
                        element-loading-spinner="el-icon-loading"
                        :data="orders"
                        ref="ordersTable"
                        :row-class-name="tableRowClassName"
                        @selection-change="handleSelectionChange"
                        :cell-style="cellStyle"
                        max-height="300"
                        border>
                      <el-table-column
                          type="selection"
                          width="55"
                          fixed="left"
                      />
                      <el-table-column
                          prop="release_at"
                          label="发布时间"
                          width="100" fixed="left">
                      </el-table-column>
                      <el-table-column
                          prop="created_date"
                          label="下单时间"
                          width="100">
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="exec_date"-->
                      <!--                          label="执行时间"-->
                      <!--                          width="100">-->
                      <!--                      </el-table-column>-->

                      <el-table-column
                          prop="customer_name"
                          label="客户名称"
                          width="120">
                      </el-table-column>
                      <el-table-column
                          prop="payment_account"
                          label="含税收入"
                          width="120" align="right" header-align="center">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment_account) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="sum_amount"
                          label="已回款金额"
                          width="120" align="right" header-align="center">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.sum_amount) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="剩余金额"
                          width="120"
                          header-align="center"
                          align="right"
                      >
                        <template slot-scope="scope">
                          <span :title="`剩余金额 = 含税收入 - 已回款金额`" class="money">{{
                              moneyFormat(scope.row.payment_account - scope.row.sum_amount)
                            }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="check_account"
                          label="已认领金额"
                          width="100" align="right" header-align="center">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.check_account) }}</span>
                        </template>
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="sum_payment"-->
                      <!--                          label="已认领金额" width="140">-->
                      <!--                      </el-table-column>-->
                      <el-table-column
                          label="快捷操作"
                          width="100" align="center" header-align="center">
                        <template slot-scope="scope">
                          <el-link type="primary" @click="setDefaultAllPayment(scope.row,scope.row.index)"><i
                              class="el-icon-check"></i>全额认领
                          </el-link>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="payment"
                          label="本次回款金额"
                          width="140" align="right" header-align="center">
                        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.payment"
                                       @change="selectInput(row,row.index)">
                          <span slot="content">
                            <span class="money">{{ moneyFormat(row.payment) }}</span>
                            <i class="el-icon-edit float-right"></i>
                          </span>
                        </editable-cell>
                      </el-table-column>
                      <el-table-column
                          prop="payment_remark"
                          label="认领备注"
                          width="140" align="left" header-align="center">
                        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.payment_remark">
                          <span slot="content">{{ row.payment_remark }}&nbsp;&nbsp;<i
                              class="el-icon-edit float-right"></i></span>
                        </editable-cell>
                      </el-table-column>
                      <el-table-column
                          prop="artist_name"
                          label="红人名称" width="100" align="center" header-align="center">
                      </el-table-column>
                      <el-table-column
                          prop="platforms"
                          label="平台" width="100" align="center" header-align="center">
                      </el-table-column>
                      <el-table-column
                          prop="brand"
                          label="品牌" width="100" align="center" header-align="center">
                      </el-table-column>
                      <el-table-column
                          prop="product"
                          label="产品/内容" width="100" align="center" header-align="center">
                      </el-table-column>
                      <el-table-column
                          prop="artist_name"
                          label="红人名称" width="100" align="center" header-align="center">
                      </el-table-column>
                      <!--                      <el-table-column-->
                      <!--                          prop="release_at"-->
                      <!--                          label="要求发布时间"-->
                      <!--                          width="100">-->
                      <!--                      </el-table-column>-->
                      <el-table-column
                          prop="bool_exec_alias"
                          label="是否执行" align="center" width="80">
                      </el-table-column>
                      <el-table-column
                          prop="pay_status_alias"
                          label="回款状态" align="center" width="80">
                      </el-table-column>
                      <el-table-column
                          prop="sale"
                          label="销售" align="center" width="80">
                      </el-table-column>
                      <el-table-column
                          prop="order_no"
                          label="订单编号" width="140">
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
              <br/>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-button type="primary" size="small" @click="submitOrders" :disabled="loadingOrder"
                             :loading="loading"
                             v-if="[-1,3].indexOf(currentRecord.claim_status)===-1&&userAuth.can_commit_pay_sheet">
                    &nbsp;&nbsp;&nbsp;&nbsp;提&nbsp;&nbsp;&nbsp;&nbsp;交&nbsp;&nbsp;&nbsp;&nbsp;
                  </el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" style="text-align: left;font-style: italic;font-weight: lighter;font-size: 12px">
                  注：找到确认回款的订单，填入“本次回款金额”，包含多笔就填对应的多笔“本次回款金额”。
                </el-col>
                <el-col :span="6" style="text-align: right">
                  已选中认领金额： <span class="my-balance-money money">{{ moneyFormat(totalPayment) }}</span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  cancelPaySheet,
  getMyPayRecordList,
  getPayRecordDetail,
  getPaySheets,
  getSellerOrders,
  tickPayRecord
} from "@/api/payRecord";
import {gFunc} from "@/globalFunc";
import EditableCell from "@/components/EditableCell.vue";
import {getOptionsForSelect} from "@/api/option";

export default {
  name: "payRecordIndex",
  components: {
    EditableCell
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
    // 已分配金额计算
    totalPayment() {
      // 计算剩余可分配金额
      let total = 0
      this.multipleSelection.forEach((item) => {
        total += item.payment * 1
      })
      return total
    },
    // 表格数据
    tableData() {
      return this.data
    },
    // ---- 分页相关配置 -------
    // 每页条数，切换
    pageSizes() {
      if (!(typeof (this.pagingData.page_size) === 'undefined') && this.pagingData.page_size < 10) {
        return [this.pagingData.page_size]
      }
      return [10, 15, 30, 50, 100, 200]
    },
    // 每一页大小，默认
    pageSize() {
      if (this.pagingData && !(typeof (this.pagingData.page_size) === 'undefined')) {
        return this.pagingData.page_size
      }
      return 10
    },
    // 初始化分页
    initPaging() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.is_show && this.pagingData.total > this.pageSize) {
          return true
        }
      }
      return false
    },
    // 数组总数
    dataTotal() {
      return this.pagingData.total
    },
    // 数据偏移量，分页序号使用
    dataOffset() {
      return typeof (this.pagingData.offset) === 'undefined' ? 0 : this.pagingData.offset
    },
    // 默认分页结构
    defaultLayout() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.layout) {
          return this.pagingData.layout
        }
      }
      return 'total, sizes, prev, pager, next, jumper'
    }
  },
  data() {
    return {
      loading: false,//数据加载中
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 50
      },
      apePageSize: 0, // 用于组件切换了每一页数据后的显示
      currentPage: 1,
      data: [],
      showCondDrawer: false,
      direction: 'rtl',
      searchCondition: {
        payer: '',
        claim_status: [],//1, 5, 2, 3, 4
        time_value: [],
        pay_method: '',
        ym: null
      },
      payMethodOptions: [
        // {value: '', label: '全部'},
        // {value: '银行收款', label: '银行收款'},
        // {value: '平台提现', label: '平台提现'},
        // {value: '支付宝', label: '支付宝'},
        // {value: '微信', label: '微信'},
        // {value: '银联', label: '银联'},
        // {value: '现金', label: '现金'},
      ],
      claimStatusOption: [
        {value: '未认领', label: 1},
        {value: '部分认领', label: 5},
        {value: '已认领', label: 2},
        {value: '部分确认', label: 4},
        {value: '全部确认', label: 3},
        {value: '已撤销', label: -1},
      ],

      dialogVisible: false,// 确认认领的数据
      currentRecord: {
        payer: '',
        bank_name: '',
        pay_date: '',
        pay_method: '',
        account: 0,//回款金额
        sum_payment: 0,//总认领金额
        other_claim_account: 0,//其他人认领
        my_claim_account: 0,//我认领
        pay_sheets: []//认领明细
      },//当前选中的记录
      loadingOrder: false,//加载
      orders: [],//匹配的订单列表
      multipleSelection: [],//修改的记录
      paySheets: [],//回款记录确认信息
      loadingSheet: false,
      searchKeyword: '',
      formOrder: {
        record_id: null,
        customer_id: null,
        customer_name: null,
        artist_name: '',
        platforms: '',
        product: '',
        pay_status: [0, 1],//0, 1
        bool_exec: null,
        time_value: []
      },//订单筛选条件
      tblHeight: 800
    }
  },
  created() {
    this.getTableSet()
    this.initList()
  },
  methods: {
    // 处理搜索结果的选中
    handleSelect(item) {
      if (item.id) {
        this.formOrder.customer_id = item.id
      } else {
        this.formOrder.customer_id = null
      }
    },
    statusClass(status) {
      switch (status) {
        case -1:
          return 'claim_status_-1'
        case 1:
          return 'claim_status_1'
        case 2:
          return 'claim_status_2'
        case 3:
          return 'claim_status_3'
        case 4:
          return 'claim_status_4'
        case 5:
          return 'claim_status_5'
        default:
          return 'claim_status_0'
      }
    },
    checkStatusClass(check_status) {
      switch (check_status) {
        case -1:
          return 'check_status_-1'
        case 1:
          return 'check_status_1'
        case 0:
          return 'claim_status_0'
        default:
          return 'check_status_0'
      }
    },
    moneyFormat(value) { // 金额 格式化
      return gFunc.numberFormat(value, 2, '.', ',', 'round')
    },
    handleChange(file) {
      this.file = [file];
    },
    beforeUpload(file) {
      this.uploadLoading = true;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("导入文件大小不能超过 5MB!");
        this.uploadLoading = false
      }
      return isLt2M;
    },
    onSubmit() {
      this.showCondDrawer = false
      this.searchRecord()
    },
    clearCondition() {
      this.searchCondition = {
        payer: '',
        claim_status: [],
        time_value: [],
        pay_method: '',
        ym: null
      }
      this.initList()
    },
    searchRecord() {
      this.currentPage = 1
      this.initList()
    },
    initList(type) {
      this.loading = true
      this.data = []
      const pagingInfo = this.getPagingInfo(type)
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      getMyPayRecordList(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          let pageData = res.model
          this.data = pageData.data
          this.pagingData.total = pageData.total * 1
          this.pagingData.page_size = pageData.per_page * 1
        }
      });
    },
    // pageSize 改变时处理
    handleSizeChange(val) {
      // this.pageSize = val
      this.apePageSize = val
      this.currentPage = 1
      this.initList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initList()
    },
    // 解决当前页数据全部删除完空白作用
    getPagingInfo(type = 'no_del') {
      if (type === 'del' && (this.pagingData.total - 1) <= (this.currentPage - 1) * this.pageSize) {
        this.currentPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : 1
      }
      const pagingInfo = {
        page_size: this.apePageSize ? this.apePageSize : this.pageSize,
        per_page: this.apePageSize ? this.apePageSize : this.pageSize,
        current_page: this.currentPage,
        page: this.currentPage

      }
      return pagingInfo
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.claim_status) {
        condition.claim_status = this.searchCondition.claim_status.join('|')
      }
      if (this.searchCondition.payer) {
        condition.payer = this.searchCondition.payer
      }
      if (this.searchCondition.pay_method) {
        condition.pay_method = this.searchCondition.pay_method
      }
      if (this.searchCondition.rec_name) {
        condition.rec_name = this.searchCondition.rec_name
      }
      if (this.searchCondition.ym) {
        condition.ym = this.searchCondition.ym
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      return condition
    },

    showSearch() {
      this.showCondDrawer = true
    },
    cancel(row) {
      this.$msgbox.confirm('此操作将撤销该回款认领, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelPaySheet({id: row.id}).then((res) => {
          if (res.success) {
            this.$message.success('操作成功')
            this.initList()
            this.dialogVisible = false
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    claimRecord(row) {
      this.currentRecord = row
      this.dialogVisible = true
      this.formOrder.customer_name = this.currentRecord.payer
      this.formOrder.record_id = this.currentRecord.id
      this.$nextTick(() => {
        this.querySubmit()//可用于认领的订单
        this.querySheets()//认领记录
      })
    },
    querySubmit() {
      this.loadingOrder = true
      this.orders = [];
      // 回款待确认订单
      if (this.formOrder.time_value) {
        this.formOrder.start_time = this.formOrder.time_value[0]
        this.formOrder.end_time = this.formOrder.time_value[1]
      }
      getSellerOrders(this.formOrder).then((res) => {
        this.loadingOrder = false
        if (res.model) {
          this.orders = res.model.data;
          // 默认选中-已认领的记录
          this.$nextTick(() => {
            for (let i = 0; i < this.orders.length; i++) {
              if (this.orders[i].sheet_id) {
                this.$refs.ordersTable.toggleRowSelection(
                    this.orders[i],
                    true
                )
              }
            }
          })
        }
      })
    },
    querySheets() {
      // 回来记录分析
      getPayRecordDetail({id: this.currentRecord.id}).then((res) => {
        if (res.model) {
          this.currentRecord = res.model.pay_record
        }
      })

      // 回款确认记录
      this.paySheets = []
      this.loadingSheet = true
      getPaySheets({record_id: this.currentRecord.id}).then((res) => {
        this.loadingSheet = false
        if (res.model) {
          this.paySheets = res.model.data
        }
      })
    },

    submitOrders() {
      // eslint-disable-next-line
      // let items = [];
      // this.orders.forEach((item) => {
      //   if (item.record_id) {
      //     items.push({
      //       order_no: item.order_no,
      //       payment: item.payment,
      //       payment_remark: item.payment_remark,
      //       record_id: item.record_id,
      //       sheet_id: item.sheet_id,
      //     })
      //   } else if (item.payment * 1 > 0) {
      //     items.push({
      //       order_no: item.order_no,
      //       payment: item.payment,
      //       payment_remark: item.payment_remark,
      //       record_id: item.record_id,
      //       sheet_id: item.sheet_id,
      //     })
      //   }
      // })
      let warningMsg = false;
      const items = [];

      for (const item of this.multipleSelection) {
        const {payment, record_id} = item;

        // 检查 payment 是否为无效值（空字符串或数值 0）
        if (payment === '' || payment === 0) {
          warningMsg = true;
          continue;
        }

        // 转换为数值并检查有效性
        const paymentValue = Number(payment);
        const isValidPayment = !isNaN(paymentValue) && (record_id || paymentValue > 0);

        if (isValidPayment) {
          items.push({
            order_no: item.order_no,
            payment: payment,
            payment_remark: item.payment_remark,
            record_id: record_id,
            sheet_id: item.sheet_id,
          });
        }
      }

      if (warningMsg) {
        this.$message.warning('认领金额不可为 0 ');
        return false;
      }
      if (items.length === 0) {
        this.$message.warning('请填写合法的本次回来金额');
        return false
      }

      tickPayRecord({items: items, record: this.currentRecord}).then((res) => {
        if (res.success) {
          this.$message.success('提交成功')
          this.querySubmit()
          this.currentRecord.claim_status = 2
          this.initList()
          this.dialogVisible = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    tableRowClassName({row, rowIndex}) {
      // // 把每一行的索引放进row.id
      row.index = rowIndex + 1
    },
    checkSelectable(row) {
      // 已对账，不能勾选
      if (row.record_id) {
        return true
      } else {
        return false
      }
    },
    selectInput(row, index) {
      this.$refs.ordersTable.toggleRowSelection(
          this.orders[index - 1],
          true
      )
      //限制认领金额上限
      if (row.payment > row.payment_account - row.sum_amount) {
        row.payment = row.payment_account - row.sum_amount
        this.$message.warning('认领金额不能大于剩余金额！！！')
      }

    },
    setDefaultAllPayment(row, index) {
      this.$refs.ordersTable.toggleRowSelection(
          this.orders[index - 1],
          true
      )
      //scope.row.payment_account - scope.row.sum_amount
      row.payment = row.payment_account - row.sum_amount
    },
    // 勾选事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //单元格的样式
    // eslint-disable-next-line
    cellStyle(row, column, rowIndex, columnIndex) {
      if (['payment', 'payment_remark'].indexOf(row.column.property) > -1) {
        return 'border: 1px dashed #409EFF;'
      } else {
        return ''
      }
    },
    //选项配置
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        let defOption = [{value: '', label: '全部'}];
        if (res.model) {
          this.payMethodOptions = res.model.pay_methods || [];
          this.payMethodOptions = [...defOption, ...this.payMethodOptions];
        } else {
          this.payMethodOptions = defOption
        }
      });
    },
    getTableSet() {
      this.tblHeight = window.screen.availHeight - 220
    }
  }
}
</script>

<style scoped>

.funcbars-button {
  padding: 3px 8px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
}

.funcbars-button i {
  width: 14px;
  height: 14px;
  font-weight: bold;
  line-height: 1.4;
  margin-right: 5px;
}

.funcbars-button i svg {
  width: 100%;
  height: 100%;
  fill: rgb(254, 45, 84);
}

.funcbars-button-loadding {
  opacity: 0.5;
}

.import-btn {
  margin-right: 20px;
  background-color: #FF5722;
  color: #ffffff !important;
  border-color: #FF5722;
}

.import-btn:active {
  background-color: #f98846;
}

.import-btn > div > div {
  color: #ffffff !important;
}

/*
 card
 */

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix {
  text-align: left;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
}

.box-card-right {
  width: 100%;
}

.total-money {
  font-weight: 700;
  font-size: 1.1rem;
}

.sum-payment {
  font-weight: 700;
  font-size: 1.3rem;
  font-style: italic;
  color: #67C23A;
}

.my-balance-money {
  color: #1E9FFF;
  font-weight: 800;
  font-size: 1.3rem;
  font-style: italic;
}

.balance-money {
  color: #F56C6C;
  font-weight: 800;
  font-size: 1.3rem;
  font-style: italic;
}

/*.balance-money::before{*/
/*  content: '剩余可分配：';*/
/*  font-style: italic;*/
/*  font-size: 16px;*/
/*}*/

.cancel {
  font-weight: lighter;
}

.success {
  font-weight: bold;
  color: #67C23A;
  font-style: italic;
}

.payer {
  font-weight: 800;
  font-size: 22px;
  padding-left: 5px;
  font-style: italic;
}

.account {
  font-weight: 400 !important;
  font-style: italic;
  margin-left: 10px;
  font-size: 1rem;
}

.cancel {
  font-weight: lighter;
}

.success {
  font-weight: bold;
  color: #67C23A;
  font-style: italic;
}

.default {
  font-weight: bold;
}

/**
认领状态样式
 */
.claim_status_0 {

}

.claim_status_1 {
  color: #409EFF;
}

.claim_status_2 {
  color: #E6A23C;
  font-weight: bold;
}

.claim_status_3 {
  color: #67C23A;
  font-weight: bold;
}

.claim_status_4 {
  color: #67c23a;
  font-weight: lighter;
  font-style: initial;
}

.claim_status_5 {
  color: #E6A23C;
  font-weight: lighter;
  font-style: initial;
}

.claim_status_-1 {
  color: #909399;
}

/**
认领回款确认状态
 */
.check_status_0 {
  color: #409EFF;
}

.check_status_-1 {
  color: #909399;
}

.check_status_1 {
  color: #67C23A;
}
</style>
<style>
.record-dialog {
  min-width: 1500px;
  width: 98%;
}
</style>
